// eslint-disable-next-line no-unused-vars
import { h } from 'preact';

const Post = ({ post }) => (
  <article className="posts-grid-with-pagination--post">
    {post.tags.length > 0 && (
      <div className="posts-grid-with-pagination--post__tags">
        {post.tags.map((postTag) => (
          <div key={postTag.id} className="deepsea-tag">
            <span>{postTag.name}</span>
          </div>
        ))}
      </div>
    )}
    <span className="posts-grid-with-pagination--post__date">{post.date}</span>
    <h4 className="posts-grid-with-pagination--post__title">{post.title}</h4>
    <div className="posts-grid-with-pagination--post__link">
      <div className="wp-block-button is-style-text is-style-icon" data-icon="arrow-right">
        <a className="wp-block-button__link wp-element-button" href={post.link}>
          Read more
        </a>
      </div>
    </div>
  </article>
);

export default Post;
